import { render, staticRenderFns } from "./AddUrl.vue?vue&type=template&id=d22c0bfe&scoped=true&"
import script from "./AddUrl.vue?vue&type=script&lang=js&"
export * from "./AddUrl.vue?vue&type=script&lang=js&"
import style0 from "./AddUrl.vue?vue&type=style&index=0&id=d22c0bfe&lang=scss&scoped=true&"
import style1 from "./AddUrl.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22c0bfe",
  null
  
)

export default component.exports